import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CartPage = () => {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadCart();
  }, []);

  const loadCart = () => {
    const savedCart = JSON.parse(localStorage.getItem('cart') || '[]');
    setCart(savedCart);
  };

  const updateQuantity = (cartKey, newQuantity) => {
    const updated = cart.map(item =>
      (item.cartKey || item.productId) === cartKey ? { ...item, quantity: Math.max(1, newQuantity) } : item
    );
    setCart(updated);
    localStorage.setItem('cart', JSON.stringify(updated));
  };

  const removeItem = (cartKey) => {
    const updated = cart.filter(item => (item.cartKey || item.productId) !== cartKey);
    setCart(updated);
    localStorage.setItem('cart', JSON.stringify(updated));
    window.dispatchEvent(new Event('storage'));
  };

  const total = cart.reduce((sum, item) => {
    const price = item.selectedPrice || item.price;
    return sum + (price * item.quantity);
  }, 0);

  if (cart.length === 0) {
    return (
      <div className="empty-cart">
        <h2>Your cart is empty</h2>
        <button onClick={() => navigate('/')}>Continue Shopping</button>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1>Shopping Cart</h1>

      <div className="cart-items">
        {cart.map(item => {
          const itemPrice = item.selectedPrice || item.price;
          return (
          <div key={item.cartKey || item.productId} className="cart-item">
            <img src={item.imageUrl} alt={item.name} />
            <div className="item-details">
              <h3>{item.name}</h3>
              {item.selectedPlatform && (
                <span className="cart-platform">{item.selectedPlatform.toUpperCase()}</span>
              )}
              <p className="item-price">${itemPrice.toFixed(2)}</p>
            </div>
            <button onClick={() => removeItem(item.cartKey || item.productId)} className="remove-btn">✕</button>
          </div>
        )})}
      </div>

      <div className="cart-summary">
        <h2>Order Summary</h2>
        <div className="summary-row">
          <span>Subtotal:</span>
          <span>${total.toFixed(2)}</span>
        </div>
        <div className="summary-row total">
          <span>Total:</span>
          <span>${total.toFixed(2)}</span>
        </div>
        <button onClick={() => navigate('/checkout')} className="checkout-btn">
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
};

export default CartPage;
